import { apiClient } from "./apiClient";

export const notificationApi = {
  list: (params = {}) =>
    apiClient.get("notifications/", { params }).then((response) => response.data),
  markAsRead: (uid) =>
    apiClient.put(`notifications/${encodeURIComponent(uid)}`, { mark_as_read: true }).then((response) => response.data),
};

export default notificationApi;
